if (!customElements.get('fluff-halloween')) {
  class FluffHalloween extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.storageKey = 'fluff-boo-hunt-2026';
      this.characters = ['ghost', 'pumpkin', 'bat'];
      this.found = new Set();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.hwMotion !== 'true';
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || '[]');
        if (Array.isArray(saved)) saved.forEach(id => { if (this.characters.includes(id)) this.found.add(id); });
        const motionChoice = sessionStorage.getItem('fluff-halloween-paused');
        if (motionChoice !== null) this.paused = motionChoice === 'true';
      } catch {}
      this.hidden = false;
      this.enhance();
      this.updateMotion();
      this.updateProgress();
      const options = { signal: this.abort.signal };
      document.addEventListener('click', event => this.handleClick(event), options);
      document.addEventListener('keydown', event => { if (event.key === 'Escape') this.closeToast(); }, options);
      document.addEventListener('shopify:section:load', () => { this.enhance(); this.updateProgress(); }, options);
      this.reducedMotion.addEventListener('change', () => this.updateMotion(), options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.toastTimer);
      clearTimeout(this.confettiTimer);
      document.body.classList.remove('fn-hw-paused');
    }
    enhance() {
      document.querySelectorAll('[data-hw-enhance]').forEach(element => { element.hidden = false; });
    }
    updateMotion() {
      const reduced = this.reducedMotion.matches;
      const stopped = this.paused || reduced;
      document.body.classList.toggle('fn-hw-paused', stopped);
      const button = this.querySelector('[data-hw-pause]');
      button.setAttribute('aria-pressed', String(stopped));
      button.disabled = reduced;
      button.title = reduced ? this.dataset.reduced : stopped ? this.dataset.play : this.dataset.pause;
      this.querySelector('[data-hw-motion-label]').textContent = button.title;
      this.querySelector('[data-hw-motion-icon]').textContent = stopped ? '▷' : 'Ⅱ';
    }
    updateProgress() {
      document.querySelectorAll('[data-hw-find]').forEach(button => {
        const found = this.found.has(button.dataset.hwFind);
        button.dataset.hwFound = String(found);
        button.setAttribute('aria-pressed', String(found));
        if (found) button.setAttribute('aria-label', button.dataset.foundLabel);
      });
      const count = this.querySelector('[data-hw-count]');
      if (count) count.textContent = this.dataset.progress.replace('[count]', String(this.found.size));
      this.querySelector('[data-hw-prize]').hidden = this.found.size !== this.characters.length;
    }
    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const find = event.target.closest('[data-hw-find]');
      if (find && this.dataset.hwHunt === 'true') {
        const id = find.dataset.hwFind;
        if (!this.characters.includes(id)) return;
        const isNew = !this.found.has(id);
        this.found.add(id);
        try { sessionStorage.setItem(this.storageKey, JSON.stringify([...this.found])); } catch {}
        this.updateProgress();
        const complete = this.found.size === this.characters.length;
        this.showToast(complete ? this.dataset.complete : find.dataset.foundMessage, complete);
        if (complete && isNew) this.celebrate();
        return;
      }
      if (!this.contains(event.target)) return;
      if (event.target.closest('[data-hw-pause]')) {
        this.paused = !this.paused;
        try { sessionStorage.setItem('fluff-halloween-paused', String(this.paused)); } catch {}
        this.updateMotion();
      } else if (event.target.closest('[data-hw-hint]')) {
        const complete = this.found.size === this.characters.length;
        this.showToast(complete ? this.dataset.complete : this.dataset.hint, complete);
      } else if (event.target.closest('[data-hw-close]')) {
        this.closeToast();
      }
    }
    showToast(message, complete) {
      clearTimeout(this.toastTimer);
      this.querySelector('[data-hw-toast]').hidden = false;
      this.querySelector('[data-hw-toast-title]').textContent = complete ? this.dataset.foundTitle : this.dataset.title;
      this.querySelector('[data-hw-message]').textContent = message;
      if (!complete) this.toastTimer = setTimeout(() => this.closeToast(), 9000);
    }
    closeToast() {
      clearTimeout(this.toastTimer);
      const toast = this.querySelector('[data-hw-toast]');
      if (toast.contains(document.activeElement)) this.querySelector('[data-hw-hint]')?.focus();
      toast.hidden = true;
    }
    celebrate() {
      if (this.paused || this.reducedMotion.matches) return;
      const stage = this.querySelector('[data-hw-confetti]');
      stage.replaceChildren();
      for (let index = 0; index < 12; index++) {
        const bit = document.createElement('span');
        bit.className = 'fn-hw-confetti__bit';
        bit.style.setProperty('--hw-x', `${(index - 5.5) * 28}px`);
        bit.style.setProperty('--hw-rotation', `${index % 2 ? 160 : -160}deg`);
        bit.style.setProperty('--hw-delay', `${index * 22}ms`);
        bit.textContent = index % 3 === 0 ? '★' : '✦';
        stage.append(bit);
      }
      clearTimeout(this.confettiTimer);
      this.confettiTimer = setTimeout(() => stage.replaceChildren(), 1800);
    }
  }
  customElements.define('fluff-halloween', FluffHalloween);
}
